/**
 * SCD Lot 0 — Catalogue de véhicules (SCD) vidé.
 * Les exports sont conservés pour compatibilité avec le moteur (fleetSlice,
 * eventSlice, bankSlice, helpers) qui devient inerte avec un catalogue vide.
 */
export const VEHICLES = [];

export const getVehicleById = (id) => VEHICLES.find(v => v.id === id);
export const getVehiclesByTier = (tier) => VEHICLES.filter(v => v.tier === tier);
